const initialState = {
    user: (() => {
        try {
            const userData = localStorage.getItem('user')
            return userData ? JSON.parse(userData) : null
        } catch (error) {
            console.error('Error parsing user data from localStorage:', error)
            return null
        }
    })(),
    company: (() => {
        try {
            const companyData = localStorage.getItem('company')
            return companyData ? JSON.parse(companyData) : null
        } catch (error) {
            console.error('Error parsing company data from localStorage:', error)
            return null
        }
    })(),
    accessToken: localStorage.getItem('access_token') || null,
    refreshToken: localStorage.getItem('refresh_token') || null,
    isAuthenticated: !!localStorage.getItem('access_token'),
    error: null,
}

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                user: action.payload.user,
                company: action.payload.company || state.company,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                isAuthenticated: true,
                error: null,
            }
        case 'LOGIN_FAILURE':
            return {
                ...state,
                user: null,
                company: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                error: action.payload,
            }
        case 'TOKEN_REFRESHED':
            return {
                ...state,
                user: action.payload.user,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                isAuthenticated: true,
                error: null,
            }
        case 'SESSION_RESTORED':
            return {
                ...state,
                user: action.payload.user,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                isAuthenticated: true,
                error: null,
            }
        case 'LOGOUT':
            return {
                ...state,
                user: null,
                company: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                error: null,
            }
        case 'AUTO_LOGOUT':
            return {
                ...state,
                user: null,
                company: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                error: action.payload,
            }
        case 'NO_SESSION':
            return {
                ...state,
                user: null,
                company: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                error: null,
            }
        case 'UPDATE_USER':
            return {
                ...state,
                user: { ...state.user, ...action.payload },
            }
        case 'UPDATE_COMPANY':
            return {
                ...state,
                company: { ...state.company, ...action.payload },
            }
        default:
            return state
    }
} 